import React from 'react';

const TargetAudience = () => {
  const audiences = [
    {
      icon: '👩‍💼',
      title: 'Para Você...',
      description: 'que já trabalha na área, mas ainda sente insegurança na hora de entregar uma henna realmente impecável, e deseja elevar o nível dos seus resultados.'
    },
    {
      icon: '📚',
      title: 'Para Você...',
      description: 'que já atende clientes, mas enfrenta dificuldades como manchas, durabilidade baixa, erro na cor ou falta de padronização nos acabamentos. '
    },
    {
      icon: '✨',
      title: 'Para Você...',
      description: 'que quer melhorar sua técnica para finalmente lotar a agenda, aumentar o valor do seu serviço e se posicionar como especialista em sobrancelhas.'
    }
  ];

  return (
    <section className="target-audience">
      <div className="container">
        <h2 className="section-title">PARA QUEM É O CURSO?</h2>
        <div className="section-divider"></div>
        
        <div className="audience-grid">
          {audiences.map((audience, index) => (
            <div key={index} className="audience-card">
              <h3>{audience.title}</h3>
              <p>{audience.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;

